<template>
    <div class="api-key-form-field">
        <div class="d-flex api-key-wrapper" :class="{ 'mt-2 mb-2': withSpace }">
            <form-input
                v-on="listeners"
                v-bind="attrs"
                class="api-key-input mb-0 pb-0"
                :floatingLabel="label"
                :value="hideApi ? keyMask : value"
                :disabled="disabled"
                :state="state"
                @input="input"
            />
            <responsive-button
                variant="primary"
                @click="hideApi = !hideApi"
                class="show-api-key"
                title="Show"
                :icon="['fas', 'eye']"
            />
            <responsive-button
                v-if="withCopy"
                variant="primary"
                @click="copyToClipboard"
                class="copy-api-key"
                title="Copy"
                :icon="['fas', 'copy']"
            />
        </div>
    </div>
</template>

<script>
    import ResponsiveButton from '../responsive-button/responsive-button.vue';
    import FormInput from '../form-input/form-input.vue';
    import { formFieldMixin } from '../../../mixins/form-field-mixin';

    export default {
        mixins: [formFieldMixin],
        components: {
            ResponsiveButton,
            FormInput,
        },
        props: {
            value: {
                type: String,
                default: '',
            },
            label: {
                type: String,
                default: '',
            },
            disabled: {
                type: Boolean,
                default: true,
            },
            withSpace: {
                type: Boolean,
                default: true,
            },
            withCopy: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            keyMask() {
                return this.value ? '●'.repeat(this.value.length) : '';
            },
        },
        data() {
            return {
                hideApi: true,
            };
        },
        methods: {
            async copyToClipboard() {
                const text = this.value;
                try {
                    await navigator.clipboard.writeText(text);
                    this.successToast({
                        text: 'Copied to clipboard successfully.',
                    });
                } catch (err) {
                    this.errorToast({
                        text: 'Something went wrong while copying to clipboard.',
                    });
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    .api-key-form-field {
        display: flex;
        flex-direction: column;
        span {
            white-space: nowrap;
        }
        .api-key-wrapper {
            .api-key-input {
                width: 100%;
                :deep(.form-control) {
                    border-top-right-radius: 0 !important;
                    border-bottom-right-radius: 0 !important;
                    width: 100%;
                }
                :deep(.input-group) {
                    flex-wrap: nowrap !important;
                }
            }
            .copy-api-key {
                border-top-left-radius: 0 !important;
                border-bottom-left-radius: 0 !important;
                margin-right: 0 !important;
            }
            .show-api-key {
                border-radius: 0;
                margin-right: 0 !important;
            }
        }
    }

    @include media-breakpoint-down(md) {
        .api-key-form-field {
            .api-key-wrapper {
                max-width: 100%;
            }
        }
    }
</style>
